import { render, staticRenderFns } from "./ConsumerBanner.vue?vue&type=template&id=4a28dbba&scoped=true&"
import script from "./ConsumerBanner.vue?vue&type=script&lang=js&"
export * from "./ConsumerBanner.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerBanner.vue?vue&type=style&index=0&id=4a28dbba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a28dbba",
  null
  
)

export default component.exports